import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@klareospace/pharos-lib-web-utils';

import { useArchiveVehicleTemplate } from '../hooks';

interface ArchiveVehicleTemplateDialogProps {
  onClose: () => void;
  vehicleTemplateId: string;
}

export function ArchiveVehicleTemplateDialog({
  onClose,
  vehicleTemplateId,
}: ArchiveVehicleTemplateDialogProps): React.JSX.Element {
  const { t } = useTranslation('settings');
  const archiveVehicleTemplate = useArchiveVehicleTemplate();

  function handleConfirm(): void {
    if (archiveVehicleTemplate.isPending) return;
    archiveVehicleTemplate.mutate(vehicleTemplateId, { onSettled: () => onClose() });
  }

  function handleOpenChange(open: boolean): void {
    if (!open) onClose();
  }

  return (
    <ConfirmDialog
      cancelLabel={t('vehicleTemplates.actions.archive.dialog.cancel')}
      confirmLabel={t('vehicleTemplates.actions.archive.dialog.confirm')}
      description={t('vehicleTemplates.actions.archive.dialog.description')}
      destructive
      isPending={archiveVehicleTemplate.isPending}
      onConfirm={handleConfirm}
      onOpenChange={handleOpenChange}
      open={!!vehicleTemplateId}
      title={t('vehicleTemplates.actions.archive.dialog.title')}
    />
  );
}
